<template>
  <div class="container">
    <div class="top-btn">
      <div class="mwow-button-filled success" @click="addHomeWork">
        发布练习
      </div>
      <div class="mwow-button large info" @click="delAll" v-debounce="1000">
        删除
      </div>
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleReset">
      <el-form size="mini" ref="form" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="练习名称:">
              <el-input
                placeholder="请搜索"
                v-model="searchInfo.title"
                @change="handleSearch"
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                clearable
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布人员:">
              <common-staff-pull-down
                :originId.sync="searchInfo.staff_id"
                :defaultSelected.sync="searchInfo.staff_list"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发布类型:" prop="type">
              <el-radio-group v-model="searchInfo.type" @change="handleSearch">
                <el-radio-button :label="-1">全部</el-radio-button>
                <el-radio-button :label="1">学员类</el-radio-button>
                <el-radio-button :label="2">课次类</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发布时间:">
              <!-- <el-date-picker
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
                v-model="searchInfo.expireTimeClass"
                @change="datechooseClass"
              >
              </el-date-picker> -->
              <common-date-range-selector
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
                v-model="searchInfo.expireTimeClass"
                @change="datechooseClass(searchInfo.expireTimeClass)"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      ref="multipleTable"
      tooltip-effect="dark"
      style="width: 100%"
      :data="tableData"
      stripe
      @selection-change="chooseItem"
      :default-sort="{ prop: 'publish_time', order: 'descending' }"
      @sort-change="clickStort"
    >
      <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column>
        <template slot="header">
          <div>
            <span>练习名称</span>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="133"
            >
              <p>红点表示有未批改的练习</p>
              <i
                class="el-icon-question"
                slot="reference"
                style="
                  margin: 0 0 0 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="sortBox mwow-green cu-po" @click="clickDetail(scope.row)">
            {{ scope.row.title }}
            <span v-if="scope.row.has_be_correct"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="发布人员" prop="staff_name">
        <template slot-scope="scope">
          {{ scope.row.staff_name || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="发布类型" prop="type">
        <template slot-scope="scope">
          <div>{{ scope.row.type === 1 ? "学员类" : "课次类" }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="发布时间"
        prop="publish_time"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
      </el-table-column>
      <el-table-column label="截止时间" prop="deadline_time"> </el-table-column>
      <el-table-column label="发布人次">
        <template slot-scope="scope">
          <div>
            {{ scope.row.total_num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="提交人次" prop="commit_num"> </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      :style="{ float: 'right', padding: '17px' }"
    >
    </el-pagination>
  </div>
</template>
<script>
import { homeworkList, homeworkDel } from "@/api/homework";
import {
  staffList,
  geteacherList,
  getSelectClassList,
  getSelectCourseList,
  searchStudent,
} from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import CommonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";

export default {
  props: ["visible"],
  components: {
    commonStaffPullDown,
    commonDateRangeSelector,
    CommonSearchFormWrapper,
  },
  data() {
    return {
      tableData: [],
      jobList: [],
      searchInfo: {
        title: "",
        staff_id: "",
        type: -1,
        expireTimeClass: [],
      },
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      page: 1,
      homework_ids: [],
    };
  },
  created() {
    if (this.$route.query.t_s_id) {
      this.searchInfo.staff_id = Number(this.$route.query.t_s_id);
    }
    // 来自教师学员关联关系页面
    if (this.$route.query.tid) {
      this.searchInfo.staff_id = Number(this.$route.query.tid);
    }
    if (
      this.$route.query.name === "week" ||
      this.$route.query.name === "month"
    ) {
      this.searchInfo.expireTimeClass[0] = new Date(this.$route.query.s_time);
      this.searchInfo.expireTimeClass[1] = new Date(this.$route.query.e_time);
      this.datechooseClass(this.searchInfo.expireTimeClass);
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleReset() {
      this.searchInfo = {
        title: "",
        staff_id: "",
        type: -1,
        expireTimeClass: [],
      };
      this.handleSearch();
    },
    clickDetail(e) {
      this.$router.push({ name: "afterDetails", query: { id: e.homework_id } });
    },
    delAll() {
      const _t = this;
      if (_t.homework_ids.length == 0) {
        _t.$message({
          type: "warning",
          message: "请选择要删除的练习",
        });
        return;
      }
      _t.$confirm(
        "删除后学员提交的练习也会一起删除，且数据无法恢复，确定要删除吗？",
        `批量删除 - 共选中 ${this.homework_ids.length} 个练习`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          _t.delHomework(_t.homework_ids);
        })
        .catch(() => {});
    },
    addHomeWork() {
      this.$router.push({ name: "addAfter" });
    },
    chooseItem(e) {
      this.homework_ids = e.map((a) => {
        return a.homework_id;
      });
    },
    // 排序
    clickStort(e) {
      this.searchInfo.sort_field = e.prop;
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.handleSearch();
    },
    delHomework(homework_id) {
      const _t = this;
      homeworkDel({ homework_ids: homework_id }).then((res) => {
        if (res.error_code == 0) {
          this.getList(
            {
              page: 1,
              page_size: _t.pageSize,
            },
            () => {}
          );
          _t.$message({
            type: "success",
            message: "删除成功",
          });
        }
      });
    },
    datechooseClass(e) {
      const _t = this;
      let expire_start_time = "";
      let expire_end_time = "";
      // if (e != null) {
      if (e) {
        expire_start_time = e[0];
        expire_end_time = e[1];
      }
      _t.searchInfo.start_time = Number(expire_start_time) / 1000;
      _t.searchInfo.end_time = Number(expire_end_time) / 1000;
      _t.searchInfo.end_time = _t.searchInfo.end_time + 3600 * 24 - 1;
      _t.handleSearch();
    },
    getList(data, cb) {
      const _t = this;
      if (_t.searchInfo.title != "") {
        data.title = _t.searchInfo.title;
      }
      if (_t.searchInfo.staff_id != "") {
        data.staff_ids = _t.searchInfo.staff_id;
      }
      if (_t.searchInfo.type > -1) {
        data.type = _t.searchInfo.type;
      }
      if (_t.searchInfo.start_time != "") {
        data.start_time = _t.searchInfo.start_time;
      }
      if (_t.searchInfo.end_time != "") {
        data.end_time = _t.searchInfo.end_time;
      }
      if (_t.searchInfo.sort_type && _t.searchInfo.sort_field) {
        data.sort_type = _t.searchInfo.sort_type;
        data.sort_field = _t.searchInfo.sort_field;
      }
      homeworkList(data).then((res) => {
        if (res.error_code == 0) {
          if (res.data.list != null) {
            res.data.list.map((a) => {
              a.publish_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(Number(a.publish_time + "000"))
              );
              a.deadline_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                new Date(Number(a.deadline_time + "000"))
              );
            });
          }
          _t.tableData = res.data.list;
          _t.total = res.data.total;
          _t.page = res.data.page;
          if (cb) {
            cb();
          }
        }
      });
    },
    handlePagerChange(e) {
      this.getList(
        {
          page: e,
          page_size: this.pageSize,
        },
        () => {}
      );
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList(
        {
          page: 1,
          page_size: e,
        },
        () => {}
      );
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  background: #fff;
}
.top-btn {
  margin-bottom: 10px;
  .mwow-button-filled {
    margin-right: 12px;
  }
}
</style>
